var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.973,
    height: 12.141,
    viewBox: "0 0 6.973 12.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-left",
    d: "M6.344.711a.3.3,0,0,1-.465,0L.164-5.031a.256.256,0,0,1,0-.437l5.715-5.742a.3.3,0,0,1,.465,0l.547.547a.281.281,0,0,1,0,.465L1.941-5.25,6.891-.3a.281.281,0,0,1,0,.465Z",
    transform: "translate(-0.041 11.32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.e825292f3d9ee172d1deb7a07929058f.svg";
export { ForwardRef as ReactComponent };